module.exports = __webpack_public_path__ + "static/media/performacemeasurement.119d4aa2.jpeg";